"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var api_internal_contract_js_1 = require("@tableau/api-internal-contract-js");
var ServiceImplBase_1 = require("./ServiceImplBase");
var VisualModelServiceImpl = /** @class */ (function (_super) {
    __extends(VisualModelServiceImpl, _super);
    function VisualModelServiceImpl() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(VisualModelServiceImpl.prototype, "serviceName", {
        get: function () {
            return "visual-model-service" /* VisualModel */;
        },
        enumerable: true,
        configurable: true
    });
    VisualModelServiceImpl.prototype.getVisualSpecificationAsync = function (visualId) {
        var _a;
        var parameters = (_a = {},
            _a[api_internal_contract_js_1.ParameterId.FunctionName] = 'getVisualSpecificationAsync',
            _a[api_internal_contract_js_1.ParameterId.WorksheetName] = visualId.worksheet,
            _a);
        return this.execute(api_internal_contract_js_1.VerbId.GetVisualSpecification, parameters).then(function (response) {
            var result = response.result;
            return result;
        });
    };
    return VisualModelServiceImpl;
}(ServiceImplBase_1.ServiceImplBase));
exports.VisualModelServiceImpl = VisualModelServiceImpl;
//# sourceMappingURL=VisualModelServiceImpl.js.map